exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input.answer{display:none}input.answer+label{padding-left:0;position:relative;border:2px solid #fff;display:block;text-align:center;cursor:pointer;margin:20px 35px;font-size:19.6px;padding:10px}input.answer+label:hover{background:#f04e23;border-color:#f04e23}@media (max-width:768px){input.answer+label{padding:10px;margin:14px 10px}}input.answer:checked+label{background:#f04e23;border-color:#f04e23}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-750226c4","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/steps/Question.vue
// module id = 62
// module chunks = 0